//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




import axios from "axios";


export default {

    props: {
        /*
        * Facebook profile
        */
        profile: {
            type: String,
            required: true,
        },
        /*
        * Facebook access token
        */
        token: {
            type: String,
            required: true,
        },
        /*
        * Number of items per load.
        */
        count: {
            type: Number,
            default: 3,
            required: false,
        },
        /*
        * Number of items to fetch per api call.
        */
        fetchCount: {
            type: Number,
            default: 24,
            required: false,
        },
        /*
        * To Display the Load more button
        */
        displayLoadMore: {
            type: Boolean,
            default: true,
            required: false,
        },
        /*
        * To Display the description
        */
        displayDescription: {
            type: Boolean,
            default: true,
            required: false,
        },
    },

    data: () => ({
        feed: [],
        /*
        *  Number of feed load.
        */
        pageLoads: 1,
        fromCache: false,
        nextId: '', // insta doesn't have an offset value for our load more, (instead we can pass it the max_id of an item which we get from the insta response), but insta also gives us the full url, so we'll just use that
        moreData: true,
    }),

    methods: {
        getUserFeed () {
            /* First check localstorage for data */

            var cachedTime = localStorage.getItem('facebooktime_'+ this.profile);

            let expiryInMinutes = 5; // 12 hours

            let fetchNewData = true;
            
            if (cachedTime !== undefined && cachedTime !== null && parseInt(cachedTime)+(expiryInMinutes * 60 * 1000) > new Date().getTime()) {

                var cachedFacebook = localStorage.getItem('facebook_'+ this.profile);
               
                if (cachedFacebook !== undefined && cachedFacebook !== null){
                    let cache =  JSON.parse(cachedFacebook);
                    this.feed = cache.feed;
                    this.nextId =  cache.nextId;
                    fetchNewData = false;
                    this.fromCache = true;
                }

            } 

            if(fetchNewData) { // Expired or localstorage data doesn't exist
                //console.warn("EXPIRED FB or FB DATA DOESNT EXIST");

                let _this = this;

                axios
                .get(`https://graph.facebook.com/v3.2/${this.profile}/posts`, { params: {access_token: this.token, limit: this.fetchCount, fields:"id,name,message,full_picture,link,type", after: this.nextId} })
                .then(function(response) {

                    _this.feed.push(...response.data.data);

                    if(response.data.paging.cursors.after !== undefined)
                        _this.nextId = response.data.paging.cursors.after;
                    else
                        _this.moreData = false;

                    localStorage.setItem('facebook_'+_this.profile, JSON.stringify({ 'feed': _this.feed, 'nextId': _this.nextId}));
                    localStorage.setItem('facebooktime_'+_this.profile, new Date().getTime());
   
                })
                .catch(function(error) {
                    console.error(error);

                    /* just get whatever we have in localstorage if available */
                    console.log("Cannot get facebook: will try to retrieve from cache");
                    var cachedFacebook = localStorage.getItem('facebook_'+ _this.profile);
               
                    if (cachedFacebook !== undefined && cachedFacebook !== null) {
                        let cache =  JSON.parse(cachedFacebook);
                        this.feed = cache.feed;
                        this.nextId =  cache.nextId;
                    }
   

                });

            }



            
        },
        fetchFeed () {
 
            //console.log(`fetching fb data`);

            let _this = this;

            axios
            .get(`https://graph.facebook.com/v3.2/${this.profile}/posts`, { params: {access_token: this.token, limit: this.fetchCount, fields:"id,name,message,full_picture,permalink_url,link,description", after: this.nextId} })
            .then(function(response) {

                _this.feed.push(...response.data.data);

                if(response.data.paging.cursors.after !== undefined)
                    _this.nextId = response.data.paging.cursors.after;
                else
                    _this.moreData = false;

                localStorage.setItem('facebook_'+ _this.profile, JSON.stringify({ 'feed': _this.feed, 'nextId': _this.nextId }));
                localStorage.setItem('facebooktime_'+ _this.profile, new Date().getTime());

            })
            .catch(function(error) {
                console.error(error);
            });
            
        },
        loadMore() {
            this.pageLoads ++; // incrementing this will automatically show any extras already in cache

            // otherwise if no extra ones already loaded or from cache 
            if(this.feed.length < this.pageLoads * this.count ) {
                this.fetchFeed();
            }
        }, 
        imageStyle(img) {
            if (!img) return;
            return {
                'background-image': `url(${img})`,
            };
        },
        itemClass(type) {
            return "facebook-feed__item--"+type;
        },
            
    },

    computed: {
        filteredData() {

            /* don't include those with type 'status', they dont have image */
            return this.feed.filter(item => item.type !== 'status');
        },
    },

    filters: {
        truncate: function (text, length, suffix = '...') {
            return text.substring(0, length) + suffix;
        },
    },
 
    created: function() {
        this.getUserFeed();
    },
    
}



// WEBPACK FOOTER //
// ./scripts/vue/FacebookFeed.vue